import { render, staticRenderFns } from "./biosecurity.vue?vue&type=template&id=4e6fcd5e&"
import script from "./biosecurity.vue?vue&type=script&lang=js&"
export * from "./biosecurity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports